import React from "react"
import { Box, Container, Typography, useTheme } from "@mui/material"
import ResponsiveBackground from "components/ResponsiveBackground"
import useScopedTranslation from "hooks/useScopedTranslation"
import en from "./locales/en.json"
import Link from "components/Link"

export const namespace = __filename

const CounterfeitReport = () => {
  const theme = useTheme()
  const { t, i18n } = useScopedTranslation(
    namespace,
    (locale) => import(`./locales/${locale}.json`),
    en
  )

  const links = {
    en: "https://www.continental-aftermarket.com/en-en/contact-authenticity-check-and-vehicle-use",
    de: "https://www.continental-aftermarket.com/de-de/kontakt-originalitaetspruefung-und-fahrzeugverwendung",
    fr: "https://www.continental-aftermarket.com/fr-fr/contacter-le-controle-doriginalite-et-lutilisation-du-vehicule",
    es: "https://www.continental-aftermarket.com/es-es/contacto-control-de-originalidad-y-uso-del-vehiculo",
    it: "https://www.continental-aftermarket.com/it-it/contatto-controllo-originalita-e-utilizzo-veicolo",
  }

  return (
    <ResponsiveBackground theme={theme}>
      <Container
        sx={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Box style={{ marginRight: 10 }}>
          <Typography fontWeight={theme.tokens.fonts_Conti.fontWeight_heavy}>
            {t("contactEmail")}
          </Typography>
          <Link
            variant={"body1"}
            text={t("reportLink")}
            path={i18n.language in links ? links[i18n.language] : links["en"]}
            style={{
              color: theme.palette.primary.main,
              fontWeight: "bold",
              marginTop: 5,
              fontSize: "16px",
            }}
          />
        </Box>
      </Container>
    </ResponsiveBackground>
  )
}

export default CounterfeitReport
